/**
 * 商品列表接口
 */
export default {
  BASE_URL: '',
  api: [
    {
      name: 'status',
      desc: '获取签收单状态',
      method: 'GET',
      path: '/tmb/collation/billStatus'
    },
    {
      name: 'overDueList',
      desc: '获取到账情况',
      method: 'GET',
      path: '/tmb/collation/account/option'
    },
    {
      name: 'verifierList',
      desc: '获取业务员列表',
      method: 'GET',
      path: '/tmb/collation/order/verifier'
    },
    {
      name: 'list',
      desc: '对账单列表',
      method: 'GET',
      path: '/tmb/collation/showList'
    },
    {
      name: 'adjustReasonList',
      desc: '调整原因选择',
      method: 'GET',
      path: '/tmb/collation/finalReason'
    },
    {
      name: 'createStatement',
      desc: '生成对账单',
      method: 'GET',
      path: '/tmb/collation/handleOrder'
    },
    {
      name: 'changeStatus',
      desc: '审批',
      method: 'POST',
      path: '/tmb/collation/handleCollation'
    },
    {
      name: 'detail',
      desc: '对账单详情',
      method: 'GET',
      path: '/tmb/collation/detail'
    },
    {
      name: 'projectDetail',
      desc: '项目详情',
      method: 'GET',
      path: '/crm/project/detail'
    },
    {
      name: 'save',
      desc: '修改对账单',
      method: 'POST',
      path: '/tmb/collation/updateCollation'
    },
    {
      name: 'exportStatement',
      desc: '导出对账单',
      method: 'POST',
      path: '/tmb/collation/export'
    },
    {
      name: 'printStatement',
      desc: '打印对账单',
      method: 'GET',
      path: '/tmb/collation/print'
    },
    {
      name: 'fallback',
      desc: '回退对账单',
      method: 'POST',
      path: '/tmb/collation/fallback'
    },
    {
      name: 'complete',
      desc: '完成对账单',
      method: 'POST',
      path: '/tmb/collation/complete'
    },
    {
      name: 'invoiceOrgNameDetail',
      desc: '获取发票单位信息名称',
      method: 'GET',
      path: '/tax/purchase/order/orgName'
    },
    {
      name: 'invoiceOrgNameDetails',
      desc: '获取发票单位信息名称',
      method: 'POST',
      path: '/tax/purchase/order/orgNames'
    },
    {
      name: 'orgNameInvoiceDetail',
      desc: '根据发票信息单位获取发票信息',
      method: 'GET',
      path: '/tax/purchase/order/info'
    },
    {
      name: 'invoiceDetail',
      desc: '获取平台增值资质发票信息',
      method: 'GET',
      path: '/tax/purchase/list'
    },
    {
      name: 'selfList',
      desc: '获取自建增值资质发票信息',
      method: 'GET',
      path: '/tax/purchase/selfList'
    },
    {
      name: 'invoiceSave',
      desc: '获取增值资质发票信息',
      method: 'GET',
      path: '/tax/purchase/insert'
    },
    {
      name: 'invoiceDelete',
      desc: '对账列表--保存/修改 订单发票信息',
      method: 'POST',
      path: '/tmb/collation/pur/invoice/save'
    },
    {
      name: 'invoiceBatchSave',
      desc: '对账列表--批量保存/修改 订单发票信息',
      method: 'POST',
      path: '/tmb/collation/pur/invoice/batch/save'
    },
    {
      name: 'delete',
      desc: '删除增值资质发票信息',
      method: 'GET',
      path: '/tax/purchase/delete'
    },
    {
      name: 'insert',
      desc: '平台新增或修改增值资质发票信息',
      method: 'POST',
      path: '/tax/purchase/insert'
    },
    {
      name: 'insertSelf',
      desc: '自建新增或修改增值资质发票信息',
      method: 'POST',
      path: '/tax/purchase/insertSelf'
    },
    {
      name: 'nameCheck',
      desc: '校验平台增值资质重名',
      method: 'GET',
      path: '/tax/purchase/checkName'
    },
    {
      name: 'selfList',
      desc: '校验自建增值资质重名',
      method: 'GET',
      path: '/tax/purchase/selfList'
    },
    {
      name: 'purInvoiceDetail',
      desc: '队长列表发票详情',
      method: 'GET',
      path: '/tmb/collation/pur/invoice/detail'
    },
    {
      name: 'statementCreate',
      desc: '生成对账单',
      method: 'GET',
      path: '/tmb/collation/handleOrder'
    },
    {
      name: 'statementDetail',
      desc: '生成对账单',
      method: 'GET',
      path: 'tmb/collation/detail'
    },
    {
      name: 'statementPayListV5',
      desc: '收/发货单列表',
      method: 'GET',
      path: '/cb/payment/record/getList'
    },
    {
      name: 'statementPayDeleteV5',
      desc: '删除收/发货单',
      method: 'GET',
      path: '/cb/payment/record/deleteById'
    },
    {
      name: 'statementPaySaveV5',
      desc: '编辑收/发货单',
      method: 'POST',
      path: '/cb/payment/record/save'
    },
    {
      name: 'statementPayExportV5',
      desc: '编辑收/发货单',
      method: 'GET',
      path: '/cb/payment/record/export'
    },
    {
      name: 'statementPayExportTemplateV5',
      desc: '获取收/发货单模板',
      method: 'GET',
      path: '/cb/payment/record/template'
    },
    {
      name: 'statementPayImportV5',
      desc: '保存倒入收/发货单数据',
      method: 'GET',
      path: '/cb/payment/record/import'
    },
    // 销售对账单
    {
      name: 'getStatusRecordV5',
      desc: '获取状态信息',
      method: 'GET',
      path: '/cb/statement/order/getStatus'
    },
    {
      name: 'createRecordV5',
      desc: '生成对账单',
      method: 'POST',
      path: '/cb/statement/order/create'
    },
    {
      name: 'updateXSCbStatementDetailV5',
      desc: '更新对账单',
      method: 'GET',
      path: '/cb/statement/order/updateXSCbStatementDetail'
    },
    {
      name: 'confirmRecordV5',
      desc: '确认对账单',
      method: 'POST',
      path: '/cb/statement/order/confirm'
    },
    {
      name: 'fetchRecordV5',
      desc: '查看对账单',
      method: 'GET',
      path: '/cb/statement/order/detail'
    },
    {
      name: 'fetchRecordListV5',
      desc: '查看对账单明细',
      method: 'GET',
      path: '/cb/statement/order/detailInfo'
    },
    {
      name: 'deleteRecordV5',
      desc: '删除对账单',
      method: 'POST',
      path: '/cb/statement/order/delete'
    },
    {
      name: 'listRecordV5',
      desc: '对账单列表',
      method: 'GET',
      path: '/cb/statement/order/list'
    },
    {
      name: 'getCustomerRecordV5',
      desc: '客户信息下拉框',
      method: 'GET',
      path: '/cb/statement/order/getCustomer'
    },
    {
      name: 'getCustomerRecordV5',
      desc: '获取供应商信息',
      method: 'GET',
      path: '/cb/statement/order/getSupplier'
    },
    {
      name: 'getProjectRecordV5',
      desc: '获取项目信息',
      method: 'GET',
      path: '/cb/statement/order/getProjectInfo'
    },
    {
      name: 'getXSOrderBaseInfoV5',
      desc: '销售对账单生成时，订单过滤接口',
      method: 'POST',
      path: '/cb/statement/order/getXSOrderBaseInfo'
    },
    // 采购对账单
    {
      name: 'createPRecordV5',
      desc: '生成对账单',
      method: 'POST',
      path: '/cb/statement/purchase/create'
    },
    {
      name: 'updateCGCbStatementDetailV5',
      desc: '更新对账单',
      method: 'GET',
      path: '/cb/statement/purchase/updateCGCbStatementDetail'
    },
    {
      name: 'confirmPRecordV5',
      desc: '确认对账单',
      method: 'POST',
      path: '/cb/statement/purchase/confirm'
    },
    {
      name: 'detailPRecordV5',
      desc: '查看对账单',
      method: 'GET',
      path: '/cb/statement/purchase/detail'
    },
    {
      name: 'detailListPRecordV5',
      desc: '查看对账单',
      method: 'GET',
      path: '/cb/statement/purchase/detailInfo'
    },
    {
      name: 'deletePRecordV5',
      desc: '删除对账单',
      method: 'POST',
      path: '/cb/statement/purchase/delete'
    },
    {
      name: 'listPRecordV5',
      desc: '对账单列表',
      method: 'GET',
      path: '/cb/statement/order/list'
    },
    {
      name: 'getCustomerPRecordV5',
      desc: '客户信息下拉框',
      method: 'GET',
      path: '/cb/statement/purchase/getCustomer'
    },
    {
      name: 'getSupplierPRecordV5',
      desc: '获取供应商信息',
      method: 'GET',
      path: '/cb/statement/purchase/getSupplier'
    },
    {
      name: 'getProjectPRecordV5',
      desc: '获取项目信息',
      method: 'GET',
      path: '/cb/statement/purchase/getProjectInfo'
    },
    {
      name: 'supPushToJinDIeV5',
      desc: '供应商流水推送/收付款单推送（单个,批量）',
      method: 'POST',
      path: '/cb/payment/record/supPushToJinDIe'
    },
    {
      name: 'cusPushToJinDIeV5',
      desc: '客户流水推送/收付款单推送（单个,批量）',
      method: 'POST',
      path: '/cb/payment/record/cusPushToJinDIe'
    },
    {
      name: 'orderList',
      desc: '收付款单推送记录',
      method: 'GET',
      path: '/push/jindie/log/orderList'
    },
    {
      name: 'getCGOrderBaseInfoV5',
      desc: '采购对账单生成时，订单过滤接口',
      method: 'POST',
      path: '/cb/statement/purchase/getCGOrderBaseInfo'
    },
    {
      name: 'deleteByIdListV5',
      desc: '采购对账单生成时，订单过滤接口',
      method: 'GET',
      path: '/cb/payment/record/deleteByIdList'
    },
    {
      name: 'bindCashFlowV5',
      desc: '首付款单绑定现金流接口（可批量）',
      method: 'POST',
      path: '/cb/payment/record/bindCashFlow'
    },
    {
      name: 'getStatusOrderNumV5',
      desc: '流水订单数量统计',
      method: 'GET',
      path: '/cb/payment/record/getStatusOrderNum'
    },
    {
      name: 'mergePurLogisticV5',
      desc: '是否合并退货单（采购）',
      method: 'POST',
      path: '/cb/statement/purchase/mergeLogistic'
    },
    {
      name: 'mergeLogisticV5',
      desc: '是否合并退货单（销售）',
      method: 'POST',
      path: '/cb/statement/order/mergeLogistic'
    },
    {
      name: 'getMainUnit',
      desc: '主体单位下拉',
      method: 'GET',
      path: '/mm/store/getBizUnitLabel'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/statement/list.js